<template>
  <layout title="Jobs" :banner="$page.props.banner" h1="Jobs" metaDescription="Du möchtest das SCOL Team tatkräftig unterstützen? Stöbere dich durch unsere Jobs und bewirb dich bei uns. Wir freuen uns auf deine Bewerbung!" metaKeywords="SCOL, SCOL Jobs, SCOL Kontakt, SCOL Skireisen, Tourismuskauffrau, Tourismuskaufmann, Jobs Reiseleiter, Jobs Tourismus, Jobs Serviceleiter, Ausbildung bei SCOL, Jobs Ski, Arbeit SCOL">
    <section id="jobs" class="scol-section py-6 bg-light">
      <div class="container-fluid">
        <div class="text-center">
          <h2 class="display-7 h1 text-secondary">Wir suchen...</h2>
        </div>
      </div>
      <!-- <div
        id="stellenangebot-werkstudent"
        class="container-lg mt-4 mt-lg-5 stellenangebot-single pb-4"
      >
        <div class="row g-0 align-items-md-center justify-md-center">
          <div class="col-md-6 p-0 overlay-right">
            <div class="inner-text inner-left bg-primary-opactiy">
              <span class="badge bg-light text-primary mb-2 fs-6 px-2"
                >... für die Wintersaison 24/25</span
              >
              <h2>
                Aushilfe/Unterstützung (m/w/d) für unser Büroteam (Nebenjob,
                Teilzeit)
              </h2>
              <p>Benefits</p>
              <ul>
                <li>Möglichkeiten von Homeoffice</li>
                <li>Skifahren möglich</li>
                <li>flexible Arbeitszeiten</li>
              </ul>
              <p>Deine Hauptaufgaben</p>
              <ul>
                <li>
                  Unterstützung unseres Teams beim Verkauf und der Abwicklung
                  unserer Reisen
                </li>
                <li class="ms-3">
                  (telefonische) Beratung und Unterstützung unserer Kunden bei
                  der Reiseplanung
                </li>
                <li class="ms-3">
                  Erstellung von individuellen Urlaubsangeboten
                </li>
                <li class="ms-3">
                  Erstellung von Buchungsbestätigungen/ Rechnungserstellung und
                  -kontrolle
                </li>
                <li class="ms-3">
                  Kontakt zu Unterkünften (Kontingentkontrolle)
                </li>
                <li>
                  mögliche Betreuung unserer Reisen vor Ort (Reiseleitung,
                  Skiguiding)
                </li>
              </ul>
              <p>Dein Profil</p>
              <ul>
                <li>abgeschlossene Schulbildung</li>
                <li>gute Kenntnisse der deutschen Sprache in Wort & Schrift</li>
                <li>Erfahrungen im Skifahren</li>
                <li>
                  gute Kenntnisse der gängigen Office Programme und sicherer
                  Umgang darin
                </li>
              </ul>
              <p>Unser Job spricht dich an? Dann bewirb dich gerne bei uns.</p>
              <p class="mt-3">
                Dein Ansprechpartner<br />Simon Koronowski<br /><a
                  href="tel:+49443596000"
                  >Tel. 0 44 35 / 9 60 00</a
                >
              </p>
            </div>
          </div>
          <div class="col-md-6 p-0">
            <div class="inner-image inner-left">
              <img
                class="img-fluid w-100"
                src="/images/scol-skireisen-jobs-werkstudent.jpg"
                alt="SCOL Skireisen Werkstudent"
              />
            </div>
          </div>
        </div>
      </div> -->
      <div
        id="stellenangebot-service"
        class="container-lg mt-4 mt-lg-5 stellenangebot-single pb-4"
      >
        <div class="row g-0 align-items-md-center justify-md-center">
          <div class="col-md-6 p-0">
            <div class="inner-image inner-left">
              <img
                class="img-fluid w-100"
                src="/images/scol-skireisen-jobs-reiseleiter-v2.jpg"
                alt="SCOL Skireisen Gruppenleiter"
              />
            </div>
          </div>
          <div class="col-md-6 p-0 overlay-right">
            <div class="inner-text inner-right bg-primary-opactiy">
              <span class="badge bg-light text-primary mb-2 fs-6 px-2"
                >... für die Wintersaison 26/27</span
              >
              <h2>Service / Reise&shy;leitung (m/w/d)</h2>
              <p>Deine Tätigkeiten</p>
              <ul>
                <li>
                  Mithilfe in unseren Hotelbetrieben in Kals oder Fügen im
                  Service/ an der Rezeption
                </li>
                <li>Skiguiding mit unseren Gästen</li>
              </ul>
              <p>Benefits</p>
              <ul>
                <li>Kost & Logis frei</li>
              </ul>
              <p>Interesse? Dann schreib uns oder ruf an für mehr Infos.</p>
              <p class="mt-3">
                Dein Ansprechpartner<br />Simon Koronowski<br /><a
                  href="tel:+49443596000"
                  >Tel. 0 44 35 / 9 60 00</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--
      Ausbildung vorübergehend ausgeblendet (Stand 06/2026).
      Stattdessen wird die Initiativbewerbung angezeigt. Bei Bedarf
      kann der Ausbildungs-Abschnitt aus der Git-Historie reaktiviert werden.
    -->
    <section class="scol-section">
      <div class="scol-section-caption">
        <h2>Initiativbewerbung</h2>
      </div>
      <div class="container container-small">
        <div class="text-center">
          <h3>Organisieren, kommunizieren, reisen - dein Ding?</h3>
          <p>Dann bewirb dich bei uns!</p>
          <p class="mt-4">
            Ganz einfach per Mail an
            <a href="mailto:info@scol.de">info@scol.de</a> oder per Post an:
            <br />
            SCOL Tours GmbH<br />
            Hauptstraße 59<br />
            26197 Großenkneten
          </p>
          <p class="mt-4">
            <strong>Dein Ansprechpartner</strong><br />
            Simon Koronowski<br />
            <a href="tel:+49443596000">Tel. 0 44 35 / 9 60 00</a>
          </p>
        </div>
      </div>
    </section>
  </layout>
</template>





<script>
import Layout from "./Layouts/Standard";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default {
  components: {
    Layout,
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    info: {
      itemsToShow: 2,
      snapAlign: "start",
      breakpoints: {
        700: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 2,
          snapAlign: "start",
        },
      },
    },
    galerie: {
      itemsToShow: 3,
      wrapAround: true,
      snapAlign: "start",
      arrows: true,
    },
  }),
};
</script>
